// Libs
import { useEffect, useState } from "react"
import { useLocCities, useLocCountries } from "hooks"

// Components
import { Form } from "components"

// Hooks
import useLocStates from "hooks/useLocStates"

export default function Loc({ isDisabled, defaultValue = {}, onChangeCity = () => {}, ...props }){

    const [ country, setCountry ] = useState(defaultValue?.country)
    const [ state, setState ] = useState(defaultValue?.state)
    const [ city, setCity ] = useState(defaultValue?.city)

    const countries = useLocCountries()
    const states = useLocStates(country)
    const cities = useLocCities(state)

    useEffect(() => {
        onChangeCity(city)
    }, [city])

    return(
    <>
    <Form.Select
        required
        label="País:"
        name="loc_country_id"
        value={country}
        options={countries.data?.map(item => ({ label: item.name, value: item.id }))}
        onChange={e => setCountry(e.target.value)}
        isDisabled={isDisabled}
        {...props}
    />

    <Form.Select
        required
        label="Estado:"
        name="loc_state_id"
        value={state}
        options={states.data?.map(item => ({ label: item.name, value: item.id }))}
        onChange={e => setState(e.target.value)}
        isDisabled={isDisabled || !country}
        {...props}
    />

    <Form.Select
        required
        label="Cidade:"
        name="loc_city_id"
        value={city}
        options={cities.data?.map(item => ({ label: item.name, value: item.id }))}
        onChange={e => setCity(e.target.value)}
        isDisabled={isDisabled || !state}
        {...props}
    />
    </>
    )
}